module.exports = __webpack_public_path__ + "img/sanguineo.bf6736f3.svg";